import {Utilities} from '@shared/utilities/utilities.model';
import {CountriesListModel} from '@shared/models/countries-list.model';
import {DatePipe} from '@angular/common';

const moment: any = require('moment');
moment.locale('it');
/**
 1) Delegato.
 Il campo ordercardelivery_vehicle_recipient_listbox va obbligatoriamente valorizzato in questo modo:
 "U" - se l'auto viene ritirata dall'utilizzatore/driver (valore di default)
 "D" - se l'auto viene ritirata da un delegato
 */

export class OrderDelivery {
	date_delivered: string;
	date_delivery_confirmation: string;
	cod_typ_order_state: string;
	date_delivery_block: string;
	date_delivery_unblock: string;
	date_delegate_license_validity: string;
	date_customermessage: string;
	date_ready: string;
	flag_cannot_deliver: string;
	flag_compatible: string;
	flag_consent: string;
	flag_customer_blocked: string;
	flag_delivery_block: string;
	flag_is_pool: string;
	flag_tyres: string;
	txt_fiscal_code_delegate: string;
	txt_fiscal_code_driver: string;
	id_order: number;
	id_order_delivery_certificate: string;
	id_order_version: number;
	ordercardelivery_date_license_release_textbox: string;
	ordercardelivery_date_license_validity_textbox: string;
	ordercardelivery_vehicle_recipient_listbox: string;
	txt_cannot_deliver_reason: string;
	txt_color_ext: string;
	txt_color_int: string;
	txt_delegate_address: string;
	txt_delegate_license_number: string;
	txt_delegate_name: string;
	txt_delegate_phone: string;
	txt_delegate_surname: string;
	txt_driver_address: string;
	txt_driver_city: string;
	txt_driver_email: string;
	txt_driver_license_by: string;
	txt_driver_license_number: string;
	txt_driver_name: string;
	txt_driver_phone: string;
	txt_driver_surname: string;
	txt_driver_zip_code: string;
	txt_make: string;
	txt_model: string;
	txt_notes: string;
	txt_plate: string;
	txt_prerent_description: string;
	txt_prerent_owner: string;
	txt_prerent_plate: string;
	txt_society_name: string;
	txt_tank_level: string;
	val_prerent_km: string;
	val_start_km: string;
	delegate_place_document_issue: string;
	delegate_citizenship: string;
	txt_template: string;

	//digital-sign driver
	txt_driver_gender: string;
	date_driver_birth: string;
	txt_driver_birthplace: string;
	txt_driver_address_number: string;
	txt_driver_license_issue_country: string;
	txt_driver_prefix_phone: string;
	citizenship:string;
	place_document_issue:string;

	//digital-sign delegate
	txt_delegate_gender: string;
	date_delegate_birth: string;
	txt_delegate_birthplace: string;
	txt_delegate_address_number: string;
	txt_delegate_license_issue_country: string;

	txt_delegate_city: string;
	txt_delegate_email: string;
	txt_delegate_license_by: string;
	txt_delegate_zip_code: string;
	date_delegate_license_release: string;

	txt_delegate_prefix_phone: string;
	txt_driver_address_country: string;

	/*digital-sign delegate*/

	txt_customer_contract_reference: string;
	private datePipe: DatePipe;

	constructor(model?: any) {
		if (model) {
			this.date_delivery_confirmation = model.date_delivery_confirmation;
			this.date_delivered = model.date_delivered;
			this.id_order_delivery_certificate = model.id_order_delivery_certificate;
			this.cod_typ_order_state = model.cod_typ_order_state;
			this.flag_cannot_deliver = model.flag_cannot_deliver;
			this.txt_cannot_deliver_reason = model.txt_cannot_deliver_reason;
			this.flag_compatible = model.flag_compatible;
			this.flag_consent = model.flag_consent;
			this.flag_customer_blocked = model.flag_customer_blocked;
			this.flag_delivery_block = model.flag_delivery_block;
			if (!Utilities.isVoid(model.flag_is_pool)) {
				this.flag_is_pool = model.flag_is_pool;
			} else {
				this.flag_is_pool = '-1';
			}
			this.flag_tyres = model.flag_tyres;
			this.date_delivery_block = model.date_delivery_block;
			this.date_delivery_unblock = model.date_delivery_unblock;
			this.id_order = model.id_order;
			this.id_order_version = model.id_order_version;
			this.txt_society_name = model.txt_society_name;
			this.txt_notes = model.txt_notes;

			//car info
			this.txt_make = model.txt_make;
			this.txt_model = model.txt_model;
			this.txt_plate = model.txt_plate;
			this.txt_tank_level = model.txt_tank_level;
			this.txt_color_ext = model.txt_color_ext;
			this.txt_color_int = model.txt_color_int;
			this.val_start_km = model.val_start_km;

			//prerent info
			this.txt_prerent_description = model.txt_prerent_description;
			this.txt_prerent_plate = model.txt_prerent_plate;
			this.txt_prerent_owner = model.txt_prerent_owner;
			this.val_prerent_km = model.val_prerent_km;

			this.txt_template = model.txt_template;
			this.txt_driver_address_country = model.txt_driver_address_country;

			this.setDriverParams(model);
			this.setDelegateParams(model);

			if (!Utilities.isVoid(model.ordercardelivery_vehicle_recipient_listbox) && model.ordercardelivery_vehicle_recipient_listbox.length > 0) {
				this.ordercardelivery_vehicle_recipient_listbox = model.ordercardelivery_vehicle_recipient_listbox;
			} else {
				this.ordercardelivery_vehicle_recipient_listbox = this.haveSameDelegateValues() ? 'D' : 'U';
			}

			this.txt_customer_contract_reference = !Utilities.isVoid(model.txt_customer_contract_reference) ? model.txt_customer_contract_reference : "";
		}
	}

	settingFromForm(model?: any) {
		if (model) {
			if (model.driver) {
				this.setDriverParams(model.driver);
			}

			if (model.delegate) {
				this.setDelegateParams(model.delegate);
			}

			this.val_start_km = model.val_start_km;
			this.txt_tank_level = model.txt_tank_level;
			this.txt_prerent_description = model.txt_prerent_description;
			this.txt_prerent_plate = model.txt_prerent_plate;
			this.txt_prerent_owner = model.txt_prerent_owner;
			this.val_prerent_km = model.val_prerent_km;
			this.flag_consent = model.flag_consent;
			this.txt_notes = model.txt_notes;
		}
	}

	private setDelegateParams(delegate: any) {
		this.txt_delegate_name = delegate.txt_delegate_name;
		this.txt_delegate_surname = delegate.txt_delegate_surname;
		if (!Utilities.isVoid(delegate.txt_fiscal_code_delegate)) {
			this.txt_fiscal_code_delegate = delegate.txt_fiscal_code_delegate.toUpperCase();
		}
		this.txt_delegate_address = delegate.txt_delegate_address;
		this.txt_delegate_license_number = delegate.txt_delegate_license_number;
		this.txt_delegate_phone = delegate.txt_delegate_phone;
		if (delegate.date_delegate_license_validity) {
			this.date_delegate_license_validity = delegate.date_delegate_license_validity;
		} else {
			this.date_delegate_license_validity = '';
		}
		if (delegate.date_delegate_license_release) {
			this.date_delegate_license_release = delegate.date_delegate_license_release;
		} else {
			this.date_delegate_license_release = '';
		}
		this.txt_delegate_city = delegate.txt_delegate_city;
		this.txt_delegate_zip_code = delegate.txt_delegate_zip_code;
		this.txt_delegate_email = delegate.txt_delegate_email;
		this.txt_delegate_license_by = delegate.txt_delegate_license_by;

		if (!Utilities.isVoid(delegate.txt_delegate_gender)) {
			this.txt_delegate_gender = delegate.txt_delegate_gender.toUpperCase();
		}
		if (delegate.date_delegate_birth) {
			this.date_delegate_birth = delegate.date_delegate_birth;
		} else {
			this.date_delegate_birth = '';
		}
		this.txt_delegate_birthplace = delegate.txt_delegate_birthplace;
		this.txt_delegate_address_number = delegate.txt_delegate_address_number;
		this.txt_delegate_license_issue_country = delegate.txt_delegate_license_issue_country;

		this.txt_delegate_prefix_phone = delegate.txt_delegate_prefix_phone;
		this.delegate_citizenship = delegate.delegate_citizenship;
		this.delegate_place_document_issue = delegate.delegate_place_document_issue;
	}

	private setDriverParams(driver: any) {	
		this.datePipe =  new DatePipe(moment.locale());
		this.txt_driver_name = driver.txt_driver_name;
		this.txt_driver_surname = driver.txt_driver_surname;
		this.txt_driver_city = driver.txt_driver_city;
		this.txt_driver_zip_code = driver.txt_driver_zip_code;
		this.txt_driver_address = driver.txt_driver_address;
		this.txt_driver_phone = driver.txt_driver_phone;
		this.txt_driver_email = driver.txt_driver_email;
		this.txt_driver_license_number = driver.txt_driver_license_number;
		this.txt_driver_license_by = driver.txt_driver_license_by;
		if (!Utilities.isVoid(driver.txt_fiscal_code_driver)) {
			this.txt_fiscal_code_driver = driver.txt_fiscal_code_driver.toUpperCase();
		}
		if (driver.ordercardelivery_date_license_release_textbox) {
			this.ordercardelivery_date_license_release_textbox = moment(driver.ordercardelivery_date_license_release_textbox, 'DD/MM/YYYY hh:mm:ss A').format('L LTS');
			
		} else {
			this.ordercardelivery_date_license_release_textbox = '';
		}

		if (driver.ordercardelivery_date_license_validity_textbox) {
			this.ordercardelivery_date_license_validity_textbox = moment(driver.ordercardelivery_date_license_validity_textbox, 'DD/MM/YYYY hh:mm:ss A').format('L LTS');
		} else {
			this.ordercardelivery_date_license_validity_textbox = '';
		}

		if (!Utilities.isVoid(driver.txt_driver_gender)) {
			this.txt_driver_gender = driver.txt_driver_gender.toUpperCase();
		}

		if (driver.date_driver_birth) {
			this.date_driver_birth = moment(driver.date_driver_birth, 'DD/MM/YYYY hh:mm:ss A').format('L LTS');			
		} else {
			this.date_driver_birth = '';
		}
		this.txt_driver_birthplace = driver.txt_driver_birthplace;
		this.txt_driver_address_number = driver.txt_driver_address_number;
		this.txt_driver_license_issue_country = driver.txt_driver_license_issue_country;
		this.txt_driver_prefix_phone = driver.txt_driver_prefix_phone;

		this.citizenship = driver.citizenship;
		this.place_document_issue = driver.place_document_issue;

	}

	getFlagValue(flag: string): boolean {
		return (!Utilities.isVoid(flag) && Number.parseInt(flag) === 1);
	}

	delegateExist(): boolean {
		return this.ordercardelivery_vehicle_recipient_listbox === 'D';
	}

	getBody(): OrderDelivery {
		const body = new OrderDelivery(this);
		if (CountriesListModel.getIsoCountryName(body.txt_driver_license_issue_country).length === 0) {
			body.txt_driver_license_issue_country = CountriesListModel.getIsoCountryCode(this.txt_driver_license_issue_country);
		}

		if (CountriesListModel.getIsoCountryName(body.txt_delegate_license_issue_country).length === 0) {
			body.txt_delegate_license_issue_country = CountriesListModel.getIsoCountryCode(this.txt_delegate_license_issue_country);
		}

		body.txt_driver_address_country = '107';
		return body;
	}

	haveSameDelegateValues(): boolean {
		return (!Utilities.isVoid(this.txt_delegate_name) && this.txt_delegate_name.length > 0)
			|| (!Utilities.isVoid(this.txt_delegate_surname) && this.txt_delegate_surname.length > 0)
	}
}
